// オート周回の時間（GAME_DESIGN 20章）。兵糧は1戦3（stamina.costMin）。1戦の時間＝決着までの手番数×secPerTurn÷倍速（無料＝Google 連携は×2、倍速パック speed4 の権利で×4）。
// 端末は通常モードでも節電モードでもこの時間が経つまで次の戦闘に進まず、サーバーは finish でこの時間が経ったかを見る。
// 閉じてから graceMinutes 分は、次に開いたときにサーバーが同じ時間の決め方で戦闘を積んで渡す。
import { CONFIG } from './config';
import { hasEntitlement, type Profile } from './profile';

/** オート周回の倍速（無料＝Google 連携は×2・倍速パック speed4 の権利で×4。オートはゲスト不可） */
export const farmSpeed = (p: Profile) => (hasEntitlement(p, 'speed4') ? CONFIG.farm.speedPaid : CONFIG.farm.speedFree);

/** 手番数 turns の1戦にかかる時間（ミリ秒） */
export const farmBattleMs = (p: Profile, turns: number) => Math.round((Math.max(1, turns) * CONFIG.farm.secPerTurn * 1000) / farmSpeed(p));

/** 閉じてからの猶予（ミリ秒） */
export const farmGraceMs = () => CONFIG.farm.graceMinutes * 60_000;
